import Auth from '../Containers/Authentication/Auth';
import Api from './Api';

class CurrentFBO {
  getId() {
    return parseInt(localStorage.currentFBOId, 10);
  }
  get() {
    const myHeaders = new Headers();
    const endPoint = 'v1/fbos';

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    return Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const fbos = response.fbos;
      if (fbos && fbos.length <= 0) return null;
      const currentFBO = fbos[0];

      localStorage.currentFBOId = currentFBO.id;

      return currentFBO;
    }).catch(() => null);
  }
}

export default new CurrentFBO();



// WEBPACK FOOTER //
// ./src/Services/CurrentFBO.js